/* eslint-disable unicorn/filename-case -- TODO rename later */
export enum SystemFileRevisionSpecifierType {
  Latest = "Latest",
  Locked = "Locked",
}

export enum SystemResourceType {
  Artifact = "Artifact",
  Model = "Model",
  // Backend snapshot-search serializes resource_type as the Python class name.
  // Files (created with API resourceType "file") use the base `Resource` class.
  File = "Resource",
  // A connected file and a container each keep their own subclass there, so neither ever reads as
  // `Resource`, and both read their content the v3 way rather than through a v2 model object.
  Connected = "ConnectedResource",
  ConnectedContainer = "ConnectedContainer",
}
